import { DEFAULT_RETRY_COUNT, schemaApi } from '../apis';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { InternalApiEntitySchema, InternalApiEntitySchemaFieldOrder, InternalApiEntityType } from '../api-internal';
import { useMe } from '../organisation/useMe';

export const useQueryEntitySchema = (entityType: InternalApiEntityType) => {
  const { currentOrganisation } = useMe();

  return useQuery({
    queryKey: ['schemas', entityType, currentOrganisation?.id],
    queryFn: () => schemaApi.findEntitySchema({ entityType }),
    retry: (failureCount, error) => error.status !== 404 && failureCount < DEFAULT_RETRY_COUNT,
  });
};

export const useUpdateEntitySchema = () => {
  const queryClient = useQueryClient();
  const { currentOrganisation } = useMe();
  return useMutation({
    mutationFn: (internalApiEntitySchema: InternalApiEntitySchema) =>
      schemaApi.updateEntitySchema({ internalApiEntitySchema }),
    onSuccess: (schema) => {
      queryClient.setQueryData(['schemas', schema.entityType, currentOrganisation?.id], schema);
    },
  });
};

export const useSortEntitySchema = () => {
  const queryClient = useQueryClient();
  const { currentOrganisation } = useMe();
  return useMutation({
    mutationFn: (internalApiEntitySchemaFieldOrder: InternalApiEntitySchemaFieldOrder) =>
      schemaApi.sortEntitySchema({ internalApiEntitySchemaFieldOrder }),
    onSuccess: (schema) => {
      queryClient.setQueryData(['schemas', schema.entityType, currentOrganisation?.id], schema);
    },
  });
};
